module.exports = __webpack_public_path__ + "static/img/4.b740d01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/4.png
// module id = BgS0
// module chunks = 1